import React from 'react';

// Reusable payment method trust badges (Visa, Mastercard, Amex, PayPal, Apple Pay, Google Pay)
// Designed for dark backgrounds - WTPL aesthetic
const Chip = ({ children, label }) => (
  <div
    className="h-7 px-2 min-w-[42px] flex items-center justify-center bg-white/[0.06] border border-white/10 rounded-md select-none"
    title={label}
    aria-label={label}
  >
    {children}
  </div>
);

export const PaymentMethodIcons = ({ size = 'default', showLabel = true, showPayPal = true, className = '' }) => {
  const compact = size === 'sm';

  return (
    <div
      data-testid="payment-method-icons"
      className={`flex flex-col items-center gap-1.5 ${className}`}
    >
      <div className={`flex flex-wrap items-center justify-center ${compact ? 'gap-1' : 'gap-1.5'}`}>
        {/* Visa */}
        <Chip label="Visa">
          <span className="text-[10px] font-extrabold italic tracking-tight text-[#7AA7FF]">VISA</span>
        </Chip>

        {/* Mastercard */}
        <Chip label="Mastercard">
          <svg width="26" height="16" viewBox="0 0 26 16" fill="none">
            <circle cx="10" cy="8" r="6.5" fill="#EB001B" />
            <circle cx="16" cy="8" r="6.5" fill="#F79E1B" />
            <path d="M13 3.1a6.48 6.48 0 0 1 0 9.8 6.48 6.48 0 0 1 0-9.8z" fill="#FF5F00" />
          </svg>
        </Chip>

        {/* Amex */}
        <Chip label="American Express">
          <span className="text-[9px] font-extrabold tracking-tight text-[#6FBFFF]">AMEX</span>
        </Chip>

        {/* PayPal (only where pack checkout supports it) */}
        {showPayPal && (
          <Chip label="PayPal">
            <span className="text-[10px] font-extrabold italic tracking-tight">
              <span className="text-[#9DB9EA]">Pay</span>
              <span className="text-[#00A8E8]">Pal</span>
            </span>
          </Chip>
        )}

        {/* Apple Pay */}
        <Chip label="Apple Pay">
          <span className="flex items-center gap-0.5">
            <svg width="12" height="14" viewBox="0 0 24 24" fill="#FFFFFF">
              <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8.98-.2 1.92-.87 3.08-.78 1.42.11 2.49.67 3.19 1.72-2.94 1.76-2.24 5.63.45 6.71-.53 1.4-1.22 2.79-2.8 4.52zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
            </svg>
            <span className="text-[10px] font-semibold text-white">Pay</span>
          </span>
        </Chip>

        {/* Google Pay */}
        <Chip label="Google Pay">
          <span className="flex items-center gap-0.5">
            <span className="text-[11px] font-bold text-[#4285F4]">G</span>
            <span className="text-[10px] font-semibold text-white">Pay</span>
          </span>
        </Chip>
      </div>

      {showLabel && (
        <div className="flex items-center gap-1.5 text-[11px] text-[#666]">
          <svg className="w-3 h-3 text-[#00D4FF]" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
          <span>Pago 100% seguro con Stripe</span>
        </div>
      )}
    </div>
  );
};

export default PaymentMethodIcons;
